module.exports = __webpack_public_path__ + "58ea10c447b5315d77cfd0e387a0696a.svg";